import { useState } from "react";
import { BellPlus, Tag, UserPlus, FileSignature, Check, X, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

const META = {
  create_reminder: { Icon: BellPlus, label: "Set a reminder", lines: (a) => [a.label, `Due ${a.date}${a.document_title ? ` · ${a.document_title}` : ""}`] },
  add_tag: { Icon: Tag, label: "Add a tag", lines: (a) => [`#${a.tag}`, a.document_title] },
  add_contact: { Icon: UserPlus, label: "Add an emergency contact", lines: (a) => [a.name, [a.role, a.phone, a.email].filter(Boolean).join(" · ")] },
  draft_letter: { Icon: FileSignature, label: "Save this letter to the vault", lines: (a) => [a.title, `${a.body.split(/\s+/).length} words`] },
};

// Confirm-before-apply card rendered under an assistant message that proposed an action.
export const ActionCard = ({ action, status, onConfirm, onDismiss }) => {
  const [busy, setBusy] = useState(false);
  const m = META[action.type];
  if (!m) return null;
  const [title, detail] = m.lines(action);
  const confirm = async () => { setBusy(true); try { await onConfirm(); } finally { setBusy(false); } };
  return (
    <div data-testid="chat-action-card" className="mt-2 rounded-xl border border-primary/30 bg-card p-2.5 text-xs">
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-mono text-primary"><m.Icon className="h-3 w-3" /> {m.label}</div>
      <div className="mt-1 font-medium text-foreground">{title}</div>
      {detail && <div className="text-muted-foreground">{detail}</div>}
      {action.type === "draft_letter" && <pre className="mt-1.5 max-h-28 overflow-y-auto whitespace-pre-wrap font-sans text-[11px] text-muted-foreground border-l-2 border-border pl-2">{action.body}</pre>}
      {status === "done" ? (
        <div data-testid="chat-action-done" className="mt-2 inline-flex items-center gap-1 text-emerald-700"><Check className="h-3 w-3" /> Done</div>
      ) : status === "dismissed" ? (
        <div data-testid="chat-action-dismissed" className="mt-2 text-muted-foreground">Skipped</div>
      ) : (
        <div className="mt-2 flex gap-1.5">
          <Button size="sm" data-testid="chat-action-confirm" disabled={busy} onClick={confirm} className="h-7 rounded-full px-3 text-[11px] gap-1">{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Check className="h-3 w-3" />} Confirm</Button>
          <Button size="sm" variant="outline" data-testid="chat-action-dismiss" disabled={busy} onClick={onDismiss} className="h-7 rounded-full px-3 text-[11px] gap-1"><X className="h-3 w-3" /> Not now</Button>
        </div>
      )}
    </div>
  );
};
